﻿export class SaveAllLinesQuoteRequest {
    public submissionId: string;
    public createProposal: boolean;
}